import { motion } from 'framer-motion';
import React from 'react';
import './CircleButton.module.scss';

type Props = {
    onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    children?: React.ReactNode;
    color?: 'red' | 'grey' | 'light-grey' | 'blue' | 'white' | 'green';
    style?: React.CSSProperties;
};

export default function CircleButton({
    children,
    color = 'blue',
    onClick,
    style,
}: Props) {
    return (
        <motion.div
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.9 }}
            onClick={onClick}
            styleName={`button ${color} `}
            style={style}
        >
            {children}
        </motion.div>
    );
}
